import React from "react";

const ButtonIcon = ({children}) => {
  return (
      <button type="button">{children}</button>
  );
};

export default ButtonIcon;
